export function formatTagDate(dateStr) {
  if (!dateStr) return "—";
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return "—";
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const yy = String(date.getFullYear()).slice(-2);
  return `${mm}/${dd}/${yy}`;
}

export function formatTagName(name) {
  const trimmed = (name || "").trim();
  if (!trimmed) return "#";
  return trimmed.startsWith("#") ? trimmed : `# ${trimmed}`;
}

export function mapTagFromApi(tag) {
  const type = tag?.type || "conversation";
  const isConversation = type === "conversation";
  const usage = tag?.usage || {};

  const usageCount = isConversation
    ? (usage.chats || 0) + (usage.tickets || 0)
    : (usage.articles ?? 0);

  return {
    id: `${type}-${tag._id}`,
    tagId: tag._id,
    tagType: type,
    typeLabel: isConversation ? "Conversation" : "Knowledge Base",
    name: tag.name,
    usage: tag.usage_count ?? usageCount,
    createdBy: tag.created_by?.full_name || "Unknown",
    createdDate: formatTagDate(tag.created_at || tag.createdAt),
  };
}

export function buildCreateTagPayload({ name, tagType, businessId }) {
  return {
    type: tagType,
    name: name.trim(),
    business_id: businessId,
  };
}
